import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
const Tabs = ({ data, changePage, isPage }) => {
    return (_jsx("div", Object.assign({ className: styles.container }, { children: data.map(item => (_jsx("div", Object.assign({ onClick: changePage.bind(null, item.id), className: isPage == item.id ? `${styles.tab} ${styles.active_tab}` : styles.tab }, { children: item.title }), item.id))) })));
};
export default Tabs;
